import React from 'react'
import '../../css/elements/jumbotron-1.css'

const Jumbotron1 = ({title, isLoading, searchLoader}) => {
  let content;

  if (Array.isArray(title)) {
    content = (
      <ol className="breadcrumb icon-angle-right">
        {title.map((item, i) => {
          if (item.url) {
            return (
              <li key={i}>
                <a href={item.url} className="text-truncate" style={{maxWidth: '400px', display: (i == 0 ? 'inherit' : 'inline')}}>
                  <u>{item.label}</u>
                </a>
              </li>)
          }
          else {
            return (<li key={i} className="active">{item.label}</li>)
          }
        })}
      </ol>)
  }
  else {
    content = title;
  }
  return (
    <div className="jumbotron jumbotron-1">
      <div className="container-fluid">
        <div className="row justify-content-between">
          <div className="col">
            <h4 className="title" style={{display:'inline-block'}}>{/*display loader in one line, prevent page moving down*/}
              {content}
              {isLoading && <img src="/assets/images/ajax-loader.gif" alt="load" style={{marginLeft: '10px'}} />}

            </h4>
                    {searchLoader && <img src="/assets/images/ajax-loader.gif" alt="load" style={{marginLeft: '10px'}} />}
          </div>
        </div>
      </div>
  </div>)
}

export default Jumbotron1
